import { h, ComponentChildren } from "preact";

import classname from "../../../foundation/utils/classname";
import Button, { ButtonProps, ButtonVariant } from "../Button";

import styles from "./InformationView.module.css";

type InformationViewButtonProps = Pick<ButtonProps, "children" | "icon" | "variant" | "readOnly" | "onClick">;

interface Props {
    class?: string;
    title?: string;
    description?: ComponentChildren;
    primaryButtonProps?: InformationViewButtonProps;
    secondaryButtonProps?: InformationViewButtonProps;
}

function InformationView({
    class: cssClass,
    title,
    description,
    primaryButtonProps,
    secondaryButtonProps
}: Props) {
    return (
        <div class={classname(styles.informationView, cssClass)}>
            {title && <span class={classname(styles.title, "heading-4 medium")}>{title}</span>}
            {description && <span class={classname(styles.description, "body-1")}>{description}</span>}
            {(primaryButtonProps || secondaryButtonProps) && (
                <div class={styles.footer}>
                    {secondaryButtonProps && (
                        <Button
                            variant={ButtonVariant.Secondary}
                            {...secondaryButtonProps}/>
                    )}
                    {primaryButtonProps && (
                        <Button
                            variant={ButtonVariant.Primary}
                            {...primaryButtonProps}/>
                    )}
                </div>
            )}
        </div>

    );
}

export default InformationView;
export {
    Props as InformationViewProps
};
